import { RefObject, useLayoutEffect, useState } from 'react';
import { useDebounceFunction } from 'shared/lib/debounce';

export const useElementHeight = (ref: RefObject<Element>, excludeValue = 0): { height: number } => {
  const [height, setHeight] = useState<number>(0);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const resizeTable = useDebounceFunction(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    const { height: nodeHeight } = node.getBoundingClientRect();
    setHeight(nodeHeight - excludeValue);
  }, 100);

  useLayoutEffect(() => {
    resizeTable();
    window.addEventListener('resize', resizeTable);

    return () => {
      window.removeEventListener('resize', resizeTable);
    };
  }, [resizeTable]);

  return { height };
};
